import React, { useContext } from 'react';
import intl from 'react-intl-universal';
import { PayContext } from './ContextProvider';
import { Tooltip } from 'antd';
import RoleList from './RoleList';
import MoreStorePlan from './MoreStorePlan';
import './PaymentDlg.scss';
import Lock from '@/assets/PaymentDlg/lock.svg';

const LeftTip = () => {
  const { isFree } = useContext(PayContext);

  const titleKey = isFree
    ? 'account.SevenTrailTitle'
    : 'account.UpgradePlan';
  const tipKey = isFree
    ? 'account.SevenTrailTip'
    : 'account.UpgradePlanTip';
  const title = intl.formatMessage({ id: titleKey });
  const tip = intl.formatMessage({ id: tipKey });

  const security = intl.formatMessage({ id: 'account.SecurityLock' });
  const securityTitle = intl.formatMessage(
    { id: 'account.SecurityLockTitle' });
  const copyright = intl.formatMessage({ id: 'account.Copyright' });

  return (
    <>
      <h3>{title}</h3>
      <p>{tip}</p>
      {!isFree ? <RoleList /> : null}
      <MoreStorePlan />
      <div className='sec-bottom'>
        <Tooltip overlayClassName='sec-bottom-title' title={securityTitle}
                 placement='topLeft' color='#ffffff'>
          <img src={Lock} alt={security} />
          <span>{security}</span>
        </Tooltip>
        <p>{copyright}</p>
      </div>
    </>
  );
};
export default LeftTip;